module.exports = __webpack_public_path__ + "static/media/make_payment.a594420a.svg";